export default __webpack_public_path__ + "static/media/monthly-cash.761fe476.webp";